export const ru = {
    'audip-genres-title': 'Жанры'
};
